import $ from 'jquery';
import { smoothscroll } from '../utils/smoothscroll';

const $habilitationsEl = $('.habilitations');

$(function () {
    if ($habilitationsEl.length > 0) {
        $habilitationsEl.each(function () {
            habilitations($(this));
        });
    }
});

const habilitations = listEl => {
    const filter = {
        page: 1,
        limit: listEl.data('limit'),
        type: listEl.data('type'),
        faculty: listEl.data('faculty'),
        frozeFirstColumn: listEl.data('froze-first-column'),
    };

    bindHabilitations(listEl, filter);
};

const reRenderList = async (element, filter, scrollTop = false) => {
    const data = await getHabilitations(filter);
    element.find('.habilitations__content').html(data.html);

    if (scrollTop === true) {
        smoothscroll(element, 'header');
    }
};

const bindHabilitations = (element, filter) => {
    element.on('click', '.pagination__item', function () {
        const $thisEl = $(this);
        filter.page = $thisEl.data('page');
        reRenderList(element, filter, true);
    });
};

const getHabilitations = async filter => {
    try {
        const response = await fetch(
            SITE_PARAMS.site_url + '/wp-json/mendelu/v1/habilitation/html',
            {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
                body: JSON.stringify(filter),
            }
        );
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};
